const leave = {
    methods: {
        leave(el, done) {
            Velocity(el, "fadeOut", {
                duration: 10,
                easing: [1000, 100],
                complete: done,
            });
        },
    },
};

const smoothEnter = {
    methods: {
        smoothEnter(el, done) {
            Velocity(
                el,
                {
                    opacity: [1, 0],
                },
                {
                    duration: 800,
                    easing: [1000, 100],
                    complete: done,
                }
            );
        },
    },
};

const rollUp = {
    methods: {
        rollUp(el, done) {
            Velocity(
                el,
                { opacity: [0, 1], height: [0, "fit-content"] },
                {
                    duration: 300,
                    easing: [1000, 100],
                    complete: done,
                }
            );
        },
    },
};

const rollDown = {
    methods: {
        rollDown(el, done) {
            Velocity(
                el,
                { opacity: [1, 0], height: ["fit-content", 0] },
                {
                    duration: 500,
                    easing: [1000, 100],
                    complete: done,
                }
            );
        },
    },
};

export { leave, smoothEnter, rollUp, rollDown };
